export const ADDRESS_SEARCH_MODAL_ID = 'address-search-modal'
